/**
 * Utility for managing Idempotency Keys across state-mutating financial operations.
 * Generates and stores UUID v4 keys in sessionStorage so keys survive in-flight tab refreshes,
 * and are cleaned up upon successful completion or definitive client-side validation errors.
 */

export function generateUUID() {
  if (typeof window !== "undefined" && window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  // RFC4122 version 4 fallback without bitwise operators (eslint-compliant)
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === "x" ? r : (r % 4) + 8;
    return v.toString(16);
  });
}

const IdempotencyManager = {
  KEY_PREFIX: "idemp_key_",

  getOrCreateKey(actionName) {
    if (typeof window === "undefined" || !window.sessionStorage) {
      return generateUUID();
    }
    const storageKey = `${this.KEY_PREFIX}${actionName}`;
    const existingKey = window.sessionStorage.getItem(storageKey);
    if (existingKey) {
      return existingKey;
    }
    const newKey = generateUUID();
    window.sessionStorage.setItem(storageKey, newKey);
    return newKey;
  },

  getKey(actionName) {
    if (typeof window === "undefined" || !window.sessionStorage) {
      return null;
    }
    const storageKey = `${this.KEY_PREFIX}${actionName}`;
    return window.sessionStorage.getItem(storageKey);
  },

  clearKey(actionName) {
    if (typeof window === "undefined" || !window.sessionStorage) {
      return;
    }
    const storageKey = `${this.KEY_PREFIX}${actionName}`;
    window.sessionStorage.removeItem(storageKey);
  },
};

export default IdempotencyManager;
